import React from "react";
import VideoComponent from "../util/VideoComponent";

const VideosComponent = (props) => {
    return (
        <div>
            {/*Videos*/}
            <VideoComponent id="HKT_V003" src={process.env.PUBLIC_URL + `/videos/HKT_V003.mp4`}/>
            <VideoComponent id="SWK_V007" src={process.env.PUBLIC_URL + `/videos/SWK_V007.mp4`}/>
            <VideoComponent id="SWK_P007" src={process.env.PUBLIC_URL + `/videos/SWK_P007.mp4`}/>

            <VideoComponent id="GBG_V008_02" src={process.env.PUBLIC_URL + `/videos/GBG_V008_02.mp4`}/>
            <VideoComponent id="HLR_V048" src={process.env.PUBLIC_URL + `/videos/HLR_V048.mp4`}/>
            <VideoComponent id="HB3_V046" src={process.env.PUBLIC_URL + `/videos/HB3_V046.mp4`}/>
            {/*<VideoComponent id="GBG_V008_03" src={process.env.PUBLIC_URL + `/videos/GBG_V008_03.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_04" src={process.env.PUBLIC_URL + `/videos/GBG_V008_04.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_05" src={process.env.PUBLIC_URL + `/videos/GBG_V008_05.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_06" src={process.env.PUBLIC_URL + `/videos/GBG_V008_06.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_07" src={process.env.PUBLIC_URL + `/videos/GBG_V008_07.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_08" src={process.env.PUBLIC_URL + `/videos/GBG_V008_08.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_09" src={process.env.PUBLIC_URL + `/videos/GBG_V008_09.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_10" src={process.env.PUBLIC_URL + `/videos/GBG_V008_10.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_12" src={process.env.PUBLIC_URL + `/videos/GBG_V008_12.mp4`}/>*/}
            {/*<VideoComponent id="GBG_V008_13" src={process.env.PUBLIC_URL + `/videos/GBG_V008_13.mp4`}/>*/}

            <VideoComponent id="HLR_V009_01" src={process.env.PUBLIC_URL + `/videos/HLR_V009_01.mp4`}/>
            <VideoComponent id="HKT_V072" src={process.env.PUBLIC_URL + `/videos/HKT_V072.mp4`}/>
            <VideoComponent id="HB4_V074" src={process.env.PUBLIC_URL + `/videos/HB4_V074.mp4`}/>
            <VideoComponent id="HKT_V020" src={process.env.PUBLIC_URL + `/videos/HKT_V020.mp4`}/>
            {/*<VideoComponent id="HKT_V072" src={process.env.PUBLIC_URL + `/videos/HKT_V072.mp4`}/>*/}
            <VideoComponent id="GFG_T070" src={process.env.PUBLIC_URL + `/videos/GHI_V061.mp4`}/>
            <VideoComponent id="HB2_V011" src={process.env.PUBLIC_URL + `/videos/HB2_V011.mp4`}/>

            {/*Audio*/}
            {/*<VideoComponent id="S02P07A01" src={process.env.PUBLIC_URL + `/audio/S02P07A01.mp3`} audio="Y"/>*/}
            <VideoComponent id="GHI_A033" src={process.env.PUBLIC_URL + `/audio/GHI_A033.mp3`} audio="Y"/>
            <VideoComponent id="HKT_P089" src={process.env.PUBLIC_URL + `/audio/HKT_P089.mp3`} audio="Y"/>

        </div>
    )
}

export default VideosComponent;
